import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import 'ace-builds/src-noconflict/mode-xml'

import { EditorWidget } from './EditorWidget'

export const EditorXmlWidget: React.FC<WidgetProps> = props => {
  return <EditorWidget mode={'xml'} {...props} />
}
